import { createApp } from "vue"
import { createPinia } from "pinia"
import { Tooltip } from "bootstrap"

import App from "./App.vue"

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */

import router from "./router"
import ElementPlus from "element-plus"
import i18n from "@/core/plugins/i18n"

//imports for app initialization
import ApiService from "@/core/services/ApiService"
import { initInlineSvg } from "@/core/plugins/inline-svg"
import { initVeeValidate } from "@/core/plugins/vee-validate"
import { initKtIcon } from "@/core/plugins/keenthemes"
import "@/core/plugins/prismjs"
import * as Sentry from "@sentry/vue"

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus)

ApiService.init(app)
initInlineSvg(app)
initKtIcon(app)
initVeeValidate()

app.use(i18n)

app.directive("tooltip", el => {
  new Tooltip(el)
})

Sentry.init({
  app,
  dsn: import.meta.env.VITE_APP_SENTRY_DNS || "",
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

app.mount("#app")
